import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from './Navbar';
import Cookies from 'js-cookie';

const NotFound = () => {
    const accessToken = Cookies.get('access_token');
    const userDetails = localStorage.getItem('userdetails');

    return (
        <>
        <Navbar />
        <div className="flex items-center justify-center min-h-screen bg-white">
            <div className="text-center text-black">
                {/* Animated Image with Motion */}
                <motion.img 
                    src="https://res.cloudinary.com/danm2mfq5/image/upload/v1735148484/yenmieafmyv9tgwgwjcn.png" 
                    alt="404 Error"
                    className="mx-auto mb-6 w-64 h-64 object-contain"
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                />

                {/* Animated 404 */}
                <motion.h1 
                    className="text-9xl font-extrabold"
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                    404
                </motion.h1>

                {/* Message */}
                <motion.p 
                    className="text-xl mt-4"
                    initial={{ opacity: 0, x: -100 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.3 }}
                >
                    Oops! The page you are looking for does not exist.
                </motion.p>

                {/* Button to redirect to Home */}
                <motion.a 
                    href={(accessToken && userDetails) ? "/home":"/"}
                    className="mt-8 inline-block px-6 py-3 bg-black text-white font-semibold rounded-lg shadow-lg hover:bg-gray-800 transition ease-in-out duration-300"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.5 }}
                >
                    Go Home
                </motion.a>
            </div>
        </div>
        </>
    );
};

export default NotFound;
